import { CommonStatusStep } from './service';

export interface IServiceFeeModelResItem {
  readonly id: number;
  readonly ModelName: string;
  readonly Status: CommonStatusStep;
  readonly ModelRelationServices: ReadonlyArray<ServiceFeeModel>;
  readonly ComputeScriptStr: string;
  readonly ScriptType: ServiceFeeScriptType;
  readonly CreatorID: number;
  readonly ModifierID?: number;
  readonly CreateTime: Date;
  readonly ModifyTime: Date;
}

export interface ICreateServiceFeeModel {
  readonly ModelName: string;
  readonly ModelRelationServices: ReadonlyArray<ServiceFeeModel>;
  readonly ComputeScriptStr: string;
  readonly ScriptType: ServiceFeeScriptType;
  readonly Status: CommonStatusStep;
}

export enum ServiceFeeScriptType {
  JS = 'js',
}

export enum ServiceFeeModel {
  // InGame在线服务计费模型
  Player = 'player',
  Party = 'party',
  Lobby = 'lobby',
  MatchMaking = 'match',
  Microservice = 'microservice',
  Goals = 'goals',
  Friends = 'friends',
  TextChat = 'chat',
  Guild = 'guild',
  LeaderBoards = 'leaderboards',
  Mails = 'mails',
  Command = 'command',
  PrivateAccess = 'private',
  Dashboard = 'dashboard',
  Telemetry = 'telemetry',
  HealthMonitor = 'healthMonitor',

  // GVoice计费模型
  VoiceChat = 'voiceChat',

  // DMP计费模型
  ContentDelivery = 'contentDelivery',

  // 扁鹊计费模型
  RemoteConfig = 'remoteConfig',
  SessionTrack = 'sessionTrack',

  // 不支持计费
  DSHosting = 'dsHosting',
  GameItems = 'gameItems',
  Store = 'store',
}

export enum IngameServiceModel {
  // InGame在线服务计费模型, 注释为免费赠送服务
  Player = 'player',
  Party = 'party',
  Lobby = 'lobby',
  MatchMaking = 'match',
  Microservice = 'microservice',
  Goals = 'goals',
  Friends = 'friends',
  TextChat = 'chat',
  Guild = 'guild',
  LeaderBoards = 'leaderboards',
  Mails = 'mails',
  // Command = 'command',
  PrivateAccess = 'private',
  // Dashboard = 'dashboard',
  // Telemetry = 'telemetry',
  // HealthMonitor = 'healthMonitor',
}

export enum CalculateFreeServices {
  // 免费赠送服务
  Command = 'command',
  Dashboard = 'dashboard',
  Telemetry = 'telemetry',
  HealthMonitor = 'healthMonitor',
}

export interface IServiceModelListItem {
  readonly ModelName: string;
  readonly ModelRelationServices: ReadonlyArray<ServiceFeeModel>;
  readonly id: number;
}

export enum GameType {
  MOBA = 'MOBA', // 多人在线 战术竞技
  Shooter = 'shooter', // 射击游戏
  RPG = 'RPG', // 角色扮演
  Strategy = 'strategy', // 策略游戏
  Card = 'card', // 卡牌
  Simulation = 'simulation', // 模拟经营
  Adventure = 'adventure', // 冒险
  Action = 'action', // 动作
  Racing = 'racing', // 竞速
  Party = 'party', // 排队
  Sports = 'sports', // 体育
  Casual = 'casual', // 休闲
  Survival = 'survival', // 生存
  OpenWorld = 'openWorld', // 开放世界
  Fighting = 'fighting', // 格斗
  Others = 'others', // 其他
}

export enum CalculateArea {
  CN = 'cn',
  INTL = 'intl',
}

export interface ICalculateBody {
  readonly area: CalculateArea;
  readonly gameType: GameType;
  readonly playerCount: string;
  readonly pcu: string;
  readonly dau: string;
  readonly mau: string;
  readonly services: ServiceFeeModel[];
}

interface IServicesResult {
  readonly name: ServiceFeeModel;
  readonly fee: number;
}

export interface ICalculateRes {
  readonly services: IServicesResult[];
  readonly subscriptionFee: number;
}

export interface IPriceSelectBody {
  readonly area?: CalculateArea;
  readonly gameType?: GameType;
  readonly playerCount?: number;
  readonly pcu?: number;
  readonly dau?: number;
  readonly mau?: number;
}
